<template>
  <div class="login-input auth-input-page">
    <div class="logo-container">
      <img
        src="/static/images/nav_logo_primary.png"
        aspect-ratio="1"
        width="174"
        class="logo-img"
      />
    </div>
    <div class="text-xs-center mt-4">
    </div>
    <form
      v-on:submit.prevent="submit()"
      autocomplete="off"
      :class="{ 'mt-2': onMobile }"
    >
      <div
        class="form-group _email text-xs-center"
        :class="{ 'has-error': errors.has('email') }"
      >
        <label class="auth-label-input d-flex">Email</label>
        <input
          class="email"
          v-model="user.email"
          v-validate="'required|email'"
          :class="{ input: true, 'text-danger': errors.has('email') }"
          name="email"
          type="email"
          placeholder=" "
          autocomplete="off"
        />
        <p
          v-if="errors.has('email')"
          class="text-danger text-xs-left mb-0"
          :class="{ 'mb-2': onMobile }"
        >
          {{ errors.first("email") }}
        </p>
      </div>

      <div class="form-group _password text-xs-center my-1">
        <label class="auth-label-input d-flex">Password</label>
        <input
          class="password"
          type="password"
          v-model="user.password"
          placeholder=" "
          autocomplete="new-password"
        />
      </div>

      <div class="text-xs-center mt-4" :class="{ 'mt-0': onMobile }">
        <v-btn
          depressed
          block
          round
          dark
          type="submit"
          class="auth-button login-btn-text"
          :class="checkUserEmpty ? 'auth-bg-disabled' : 'auth-bg-active'"
          :loading="loading"
        >
          Login
        </v-btn>
        <div class="forgot-password mb-4 mt-5">
          <span
            class="forgot-password-text cursor-pointer"
            @click="!showForgotPassword ? $route.push('/forgot') : showForgotPassword()"
          >
            Forgot password
          </span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import AuthService from "@/services/auth.js";
import { mapGetters } from "vuex";
import { MyEvents } from "@/helper";

export default {
  props: {
    showForgotPassword: Function,
  },
  data() {
    return {
      loading: false,
      remember: false,
      user: {
        email: this.$route.query.email || "",
        password: "",
      },
    };
  },
  computed: {
    onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    ...mapGetters({
      isAuthenticated: "auth/isAuthenticated",
    }),
    checkUserEmpty() {
      return this.user.email == "" || this.user.password == "";
    },
  },
  created() {
    let myAlert = null;
    try {
      myAlert = JSON.parse(atob(this.$route.query["alert"]));
    } catch (e) {
      myAlert = null;
    }
    if (this.isAuthenticated) {
      return;
    }
    const user = AuthService.loadCredential();
    if (user !== null) {
      this.user.email = user.email;
      this.user.password = user.password;
    }
    this.$store.dispatch("navigator/goNextState", { page: "login", tab: "" });

    if (myAlert) {
      switch (myAlert.type) {
        case "success":
          this.$store.dispatch("error/showSuccessToast", myAlert.messages);
          break;
        case "error":
          this.$store.dispatch("error/showErrorToast", myAlert.messages);
          break;
      }
    }

    this.$nextTick(() => {
      this.$root.$emit(MyEvents.AUTH_SIGNOUT);
    });
  },
  methods: {
    submit() {
      this.loading = true;
      this.$store.dispatch("error/showLoadingActivity", true);
      AuthService.login(this.user)
        .then((response) => {
          if (this.remember) {
            AuthService.saveCredential(this.user);
          }
          AuthService.setTokenAndUserInfo(response.body);

          if (response.body.sign_in_count <= 1) {
            this.$store.dispatch("auth/setFirstVisit", true);
          }

          this.$root.$emit(MyEvents.AUTH_SIGNIN);

          this.$store.dispatch("error/showLoadingActivity", false);
          if (
            this.$store.state.auth.user.user_type === "listener" ||
            this.$store.state.auth.user.user_type === "admin"
          )
            window.location.href = "/settings";
          else window.location.href = "/upload/album";
        })
        .catch((e) => {
          if (e.body.errors[0].message == "not authorized")
          {
            this.$router.push({ path: `/welcome?username=${e.body.errors[0].username}` });
            return
          }

          this.$router.push({ path: `/login?email=${this.user.email}` });
          this.loading = false;

          this.$store.dispatch("error/showLoadingActivity", false);
          this.$store.dispatch(
            "error/showErrorToast",
            e.body.errors || [e.body]
          );
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-input {
  position: relative;
  .logo-container {
    text-align: center;
    margin-bottom: 20px; /* Adjust this value as needed */
  }
  .logo-img {
    display: inline-block;
    margin-top: 20px; /* Adjust this value as needed */
    margin-bottom: 20px;
  }
}

.login-btn-text {
  font-size: 16px !important; /* Adjust this value as needed */
}
</style>



// WEBPACK FOOTER //
// loginInput.vue?359498f0